import React from 'react';
import { toHref } from '@peloton/external-links/models';
import { getExtLinkEnv } from '@peloton/external-links/redux';
import { Links } from '@peloton/links';
import { track as trackAction } from '@engage/analytics/actions';
import { useReduxState, useReduxAction } from '@engage/redux/hooks';
import type { Subscription } from '@engage/subscriptions/Subscription';
import { getDaysUntilNextBilling } from '@engage/subscriptions/Subscription';
import { useSubscriptions } from '@members/copy/copy.generated';
import { Subscriptions } from '@members/copy/models.generated/Subscriptions';
import BannerView, { animationDurationInSeconds } from '../Banner';
import {
  dismissExpiringSoonBanner as dismissExpiringSoonBannerAction,
  didDismissExpiringSoonBanner,
} from '../redux';
import { toTrackViewed, toTrackClickUpgrade, toTrackDismissedBanner } from './analytics';

export const ExpiringSoon: React.FC<
  React.PropsWithChildren<{ activePrimaryDigitalTrial: Subscription }>
> = ({ activePrimaryDigitalTrial }) => {
  const daysRemaining = getDaysUntilNextBilling(activePrimaryDigitalTrial);
  const dismissed = useReduxState(didDismissExpiringSoonBanner);
  const dismissExpiringSoonBanner = useReduxAction(dismissExpiringSoonBannerAction);
  const track = useReduxAction(trackAction);

  const linkEnv = useReduxState(getExtLinkEnv);
  const url = toHref(Links.digitalCheckoutMonthToMonth, linkEnv);

  const message = useSubscriptions(Subscriptions.ExpiringSoonCta, { daysRemaining });
  const ctaText = useSubscriptions(Subscriptions.UpgradeNowCta);

  const ctaAction = () => {
    track(toTrackClickUpgrade(daysRemaining));
    window.location.href = url;
  };
  const closeHandler = () => {
    track(toTrackDismissedBanner(daysRemaining));
    setTimeout(() => dismissExpiringSoonBanner, animationDurationInSeconds * 1.5 * 1000);
  };

  const tracker = () => {
    track(toTrackViewed(daysRemaining));
  };

  return daysRemaining > 3 || dismissed ? null : (
    <BannerView
      message={message}
      ctaText={ctaText}
      tracker={tracker}
      ctaAction={ctaAction}
      closeHandler={closeHandler}
    />
  );
};
